import React from 'react';
import Banner from '../components/banner';
import FrontDescription from '../components/front-description';
import Services from '../components/services';
import PreFooter from '../components/pre-footer';
import bannerIndex from '../images/shutterstock_653993329.jpg';

const IndexPage = props =>
  (<main>
    <Banner
      title="Ihr kompetenter Partner in Sachen Steuerberatung, Wirtschaftsprüfung, k‌aufmännische Dienstleistungen."
      image={bannerIndex}
      rightAligned={true}
    />
    <FrontDescription />
    <Services
      taxAdvice={true}
      businessAdvice={true}
      servicesInCooperation={true}
      accounting={true}
      businessValuation={true}
    />
    <PreFooter />
  </main>);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js